/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-06-29 17:17:12
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-06 11:24:09
 * @FilePath: \合联\oms\src\api\costRule\storageCostQuoteRule.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
let name = '/rule/warehouseClient'

export const apis = buildApi({
  get: [name + '/index&list',],
  post: [name + '/save', name + '/delete/:id&del']
})